import { generateReadActionCreator } from "actions/crudActionCreators";
import ACTION_NAMES from "actions/ACTION_NAMES";
import routes from '../routes';

export default {
    getConversionData: generateReadActionCreator(`${routes.API_USER_DASHBOARD}/conversion`, ACTION_NAMES.USER_CONVERSION_DATA),
    getFunnelData: generateReadActionCreator(`${routes.API_USER_DASHBOARD}/funnel`, ACTION_NAMES.USER_FUNNEL_DATA),
    getPipelineReport: generateReadActionCreator(`${routes.API_DASHBOARD}/pipeline_report`, ACTION_NAMES.GET_PIPELINE_REPORT),
    getCallHistoryReport: generateReadActionCreator(`${routes.API_DASHBOARD}/call_history_report`, ACTION_NAMES.GET_CALL_HISTORY_REPORT),
    getCallsReport: generateReadActionCreator(`${routes.API_DASHBOARD}/calls_report`, ACTION_NAMES.GET_CALLS_REPORT),
    getRecentRecords: generateReadActionCreator(`${routes.API_DASHBOARD}/recent`, ACTION_NAMES.GET_RECENT_RECORDS),
}
